<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Raklap kimutatás</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="20" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="fetchData"
              />
            </el-form-item>
            <el-form-item style="margin-right: 10px;"
                          label="Beszállító"
            >
              <el-select
                v-model="partner"
                filterable
                remote
                :remote-method="searchPartner"
                :loading="partnerLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in partners"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :data="report.items"
        style="width: 100%"
        row-key="id"
        border
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column
          prop="partner_name"
          label="Partner"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.partner_name }}
          </template>
        </el-table-column>

        <template
          v-for="pallet in report.pallets"
        >
          <el-table-column
            v-bind:key="pallet.id + '_in'"
            :prop="pallet.id + '_in'"
            :label="pallet.name + ' érkezett'"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row[pallet.id + '_in_count'] }}
            </template>
          </el-table-column>

          <el-table-column
            v-bind:key="pallet.id+ '_out'"
            :prop="pallet.id + '_out'"
            :label="pallet.name + ' kiment'"
            align="right"

          >
            <template slot-scope="scope">
              {{ scope.row[pallet.id + '_out_count'] }}
            </template>
          </el-table-column>

          <el-table-column
            v-bind:key="pallet.id + '_sum'"
            :prop="pallet.id + '_sum'"
            :label="pallet.name + ' össz.'"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row[pallet.id + '_sum'] }}
            </template>
          </el-table-column>
        </template>

        <el-table-column
          prop="summary"
          label="Végösszeg"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.summary }}
          </template>
        </el-table-column>
      </el-table>

    </div>
  </el-card>
</template>

<script>

import { saveAs } from 'file-saver';
import moment from 'moment';


export default {
  components: {},
  data() {
    const start = moment()
      .startOf('year')
      .format('Y-MM-DD');
    const end = moment()
      .format('Y-MM-DD');
    return {
      report: {},
      loading: false,
      downloadLoading: false,
      printLoading: false,
      partnerLoading: false,
      partner: null,
      partners: [],
      dateRange: [start, end],
      dateRangeOptions: {
        firstDayOfWeek: 1,
        shortcuts: [{
          text: 'Aktuális hét',
          onClick(picker) {
            const start = moment()
              .weekday(1)
              .toDate();
            const end = moment()
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hét',
          onClick(picker) {
            const start = moment()
              .subtract({ weeks: 1 })
              .weekday(1)
              .toDate();
            const end = moment()
              .subtract({ weeks: 1 })
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális hónap',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 1 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző 3 hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 3 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális év',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző év',
          onClick(picker) {
            const start = moment()
              .subtract({ years: 1 })
              .startOf('year')
              .toDate();
            const end = moment()
              .subtract({ years: 1 })
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'YTD',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'MTD',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },
  computed: {},
  async mounted() {
    this.fetchData();
  },
  methods: {
    async download() {
      this.downloadLoading = true;
      try {
        const excel = await axios({
          url: `api/reports/pallet/download`,
          method: 'POST',
          responseType: 'blob',
          data: {
            from: this.dateRange[0],
            to: this.dateRange[1],
            supplier_id: this.partner ? this.partner.id : null,
          },
        });
        saveAs(excel, `pallet.xlsx`);
      } catch (e) {
      }
      this.downloadLoading = false;
    },

    handleSortChange({ column, prop, order }) {
    },

    getSummaries() {
      return this.report.hasOwnProperty('summary') ? [
        'Összesen',
        ...Object.values(this.report.summary)
      ] : [];
    },

    async searchPartner(query) {
      if (query !== '') {
        this.partnerLoading = true;
        this.partners = await this.$store.dispatch('partner/search', '?name=' + query + '&is_supplier=true');
        this.partnerLoading = false;
      }
    },
    async fetchData() {
      this.loading = true;
      let query = `api/reports/pallet?from=${this.dateRange[0]}&to=${this.dateRange[1]}`;

      if (this.partner) {
        query += `&supplier_id=${this.partner.id}`;
      }

      this.report = await axios.get(query);
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
